import AnswersPage from "./AnswersPage";

export default AnswersPage;
